import { render } from "./AppBaseLimit.vue?vue&type=template&id=df35f48e&scoped=true"
import script from "./AppBaseLimit.vue?vue&type=script&lang=js"
export * from "./AppBaseLimit.vue?vue&type=script&lang=js"

import "./AppBaseLimit.vue?vue&type=style&index=0&id=df35f48e&lang=scss&scoped=true"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df35f48e"]])

export default __exports__